module.exports = __webpack_public_path__ + "static/img/04.96a9b57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/05/04.jpg
// module id = A0m8
// module chunks = 1